import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Generic from '../Generic';

//Components
import InputField from './InputField';

const Content = styled.div`
  display: flex;
  flex: 1 0 auto;
  padding: 10px;
`

const InputFieldStyled = styled(InputField)`

`

const InputType = ({
  type,
  children,
  defaultValue,
  value,
  onChange,
  ...other
}) => {
  return (
    <Generic {...other}>
      <Content>
        {children}
      </Content>
      <InputFieldStyled
        type={type}
        value={value}
        onChange={onChange}
      />
    </Generic>
  )
}

InputType.propTypes = {
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string,
};

InputType.defaultProps = {
  type: null,
};

export default InputType;
